export type ArgsLslOutlet = {
	sessionId: string;
	streamName: string;
	chunkNo: number;
	binaryData: Blob;
};

export class Api {
	protected mBaseURL: string;
	protected mAccessToken: string;

	constructor(
		a_baseURL: string,
		a_accessToken: string)
	{
		this.mBaseURL = a_baseURL;
		this.mAccessToken = a_accessToken;
	}

	async lslOutlet( a_argsLslOutlet: ArgsLslOutlet): Promise<Response>
	{
		const fullUrl = new URL(`${this.mBaseURL}/lslOutlet`);
		fullUrl.searchParams.append('s', a_argsLslOutlet.streamName);
		fullUrl.searchParams.append('c', a_argsLslOutlet.chunkNo.toString());
      
		const headers = new Headers();
		headers.append('x-token', this.mAccessToken);
		headers.append('x-session-id', a_argsLslOutlet.sessionId);
		headers.append('Content-Type', 'application/octet-stream');
		const requestOptions: RequestInit = {
			method: 'PUT',
			headers: headers,
			body: a_argsLslOutlet.binaryData,
			redirect: 'follow'
		};
      		return fetch(fullUrl.toString(), requestOptions);
	}
}

/*
	// Usage example:
	const apiV1 = new ApiV1('api-v1.fipok.com', '<my-access-token>');
	await ApiV1.lslOutlet({
		sessionId: '<sessionId>',
		streamName: 'GameLog'
		chunkNo: 5;
		binaryData: Blob([[/ * your binary data here * /]])})
	.then(response => response.text())
      	.then(result => console.log(result))
      	.catch(error => console.log('error', error));
*/